import React from 'react';
import styles from './patientFormObjectFieldTemplate.module.scss';

// Groups the (already sort_order-ordered) properties array by row_order, the same way the
// admin-side form-loader.js (@carecloud/breeze-practice-forms) does it: consecutive properties
// sharing a row_order become one group; anything without a row_order (forms saved before
// multi-column support existed) gets its own unique group, so it renders exactly as it always
// has — one field per row, no wrapper.
const groupByRow = (properties, schemaProperties) => {
  const groups = [];
  let currentGroup = null;
  properties.forEach(property => {
    const fieldSchema = schemaProperties[property.name] || {};
    const rowKey = fieldSchema.row_order !== undefined ? `r${fieldSchema.row_order}` : `p${property.name}`;
    if (currentGroup && currentGroup.rowKey === rowKey) {
      currentGroup.items.push(property);
    } else {
      currentGroup = { rowKey, items: [property] };
      groups.push(currentGroup);
    }
  });
  return groups;
};

const PatientFormObjectFieldTemplate = ({ properties, schema }) => {
  const schemaProperties = (schema && schema.properties) || {};
  const groups = groupByRow(properties, schemaProperties);

  return (
    <div>
      {groups.map(group => {
        if (group.items.length === 1) {
          const property = group.items[0];
          return <React.Fragment key={property.name}>{property.content}</React.Fragment>;
        }

        const sortedItems = [...group.items].sort((a, b) => {
          const aOrder = (schemaProperties[a.name] || {}).column_order || 0;
          const bOrder = (schemaProperties[b.name] || {}).column_order || 0;
          return aOrder - bOrder;
        });
        const hasTextSibling = sortedItems.some(item => (schemaProperties[item.name] || {}).field_type === 'help');

        return (
          <div className={styles.patientFormRow} key={group.rowKey}>
            {sortedItems.map(property => {
              const fieldType = (schemaProperties[property.name] || {}).field_type;
              let colClassName = styles.patientFormCol;
              if (fieldType === 'help') {
                colClassName += ` ${styles.patientFormColText}`;
              } else if (fieldType === 'input' && hasTextSibling) {
                colClassName += ` ${styles.patientFormColBlank}`;
              } else {
                colClassName += ` ${styles.patientFormColEqual}`;
              }
              return (
                <div className={colClassName} key={property.name}>
                  {property.content}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default PatientFormObjectFieldTemplate;
